import { render, staticRenderFns } from "./SimilarProjectDialog.vue?vue&type=template&id=af182fda&scoped=true"
import script from "./SimilarProjectDialog.vue?vue&type=script&lang=js"
export * from "./SimilarProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./SimilarProjectDialog.vue?vue&type=style&index=0&id=af182fda&prod&lang=css"
import style1 from "../../css/newCreateProject.css?vue&type=style&index=1&id=af182fda&prod&scoped=true&lang=css&external"
import style2 from "./SimilarProjectDialog.vue?vue&type=style&index=2&id=af182fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af182fda",
  null
  
)

export default component.exports